import { Box, Tooltip } from '@mui/material';
import { Chip } from '@molecules';
import { formatDate, parseAmount } from '@utils';
import { styles } from './styles';

export interface NamelessCardBulk {
  id: string;
  customerId: number;
  attemptedAmount: number;
  dispersedAmount: number | null;
  dispersedCount: number;
  status: 'pending' | 'processing' | 'processed' | 'failed';
  transactionId: string;
  executedBy: string;
  createdAt: Date | string;
  updatedAt: Date | string;
  deletedAt: Date | string | null;
}

export const STATUSES: {
  [key in NamelessCardBulk['status']]: {
    label: string;
    color:
      | 'primary'
      | 'success'
      | 'error'
      | 'default'
      | 'secondary'
      | 'info'
      | 'warning'
      | undefined;
    tooltip?: string;
  };
} = {
  pending: {
    label: 'COMMON:PENDING',
    color: 'default',
    tooltip: 'DISPERSIONS:STATUS_DESCRIPTION_PENDING',
  },
  processing: {
    label: 'COMMON:PROCESSING',
    color: 'primary',
  },
  processed: { label: 'COMMON:COMPLETED', color: 'success' },
  failed: {
    label: 'COMMON:FAILED',
    color: 'error',
    tooltip: 'DISPERSIONS:STATUS_DESCRIPTION_FAILED',
  },
};

export const COLUMNS = [
  {
    title: 'DISPERSIONS:UPLOAD_DATE',
    content: (row: NamelessCardBulk) => formatDate(row.createdAt),
  },
  {
    title: 'COMMON:USER',
    content: (row: NamelessCardBulk) => {
      return (
        <Tooltip title={row.executedBy} arrow>
          <Box sx={[styles.rowEllipsis, styles.nameMaxWidth]}>{row.executedBy}</Box>
        </Tooltip>
      );
    },
  },
  {
    title: 'DISPERSIONS:ATTEMPTED_AMOUNT',
    content: (row: NamelessCardBulk) => parseAmount(row.attemptedAmount),
  },
  {
    title: 'DISPERSIONS:DISPERSED_AMOUNT',
    content: (row: NamelessCardBulk) =>
      (row.dispersedAmount != null && parseAmount(row.dispersedAmount)) || '-',
  },
  {
    title: 'COMMON:STATUS',
    content: (row: NamelessCardBulk) => {
      const statusProps = STATUSES[row.status] || {};
      return <Chip {...statusProps} variant='outlined' sx={styles.chip} />;
    },
  },
];

export const DEFAULT_PAGE_LIMIT = 25;
